import React from "react";
import { Redirect } from "react-router";

import LoginPage from "../../components/pages/Login";
import Spinner from "../../components/utils/Spinner";
import { LoginRequestState } from "../reducer";
import { ILoginProps } from "./types";

export const LoginComponent: React.FC<ILoginProps> = props => {
  const {
    authenticationState: { isAuthenticated, isKnown },
    onLogin,
    loginRequestState,
    loginRequestError,
  } = props;

  if (!isKnown) {
    return <Spinner data-testid="spinner" />;
  }

  if (isAuthenticated) {
    const { from } = props.location.state || { from: { pathname: "/" } };
    return <Redirect to={from} />;
  }

  return (
    <LoginPage
      isLoading={loginRequestState === LoginRequestState.PENDING}
      error={loginRequestError}
      onSubmit={onLogin}
    />
  );
};
